import { styled } from '@mui/material/styles';

import { LoadingButton } from 'shared/components/buttons/LoadingButton';

export const LocaleButton = styled(LoadingButton)(({ theme }) => ({
  textTransform: 'uppercase',

  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2.5, 0, 5),
    paddingLeft: theme.spacing(3.5),
    paddingRight: theme.spacing(3),

    '> .MuiButton-endIcon': {
      marginLeft: 'auto',
    },
  },
}));
